import { useBreakpoints } from '@vueuse/core'

const breakpoints = useBreakpoints({
  mobile: 960,
})

const isMobile = breakpoints.smaller('mobile')

export default isMobile
